var InsuranceData = {
    "product_id": 7223589175385,
    "basic_variant": 40389984125017,
    "threshold_price": 100.00,
    "basic_variant": 40389984125017,
    "basic_price": 1.98,
    "variants":[{"name":"Basic Shipping Protection","price":"1.98","id":40389984125017},{"name":"A$2.42","price":"2.42","id":40389984157785},{"name":"A$2.53","price":"2.53","id":40389984190553},{"name":"A$2.65","price":"2.65","id":40389984223321},{"name":"A$2.76","price":"2.76","id":40389984256089},{"name":"A$2.88","price":"2.88","id":40389984288857},{"name":"A$2.99","price":"2.99","id":40389984321625},{"name":"A$3.11","price":"3.11","id":40389984354393},{"name":"A$3.22","price":"3.22","id":40389984387161},{"name":"A$3.34","price":"3.34","id":40389984419929},{"name":"A$3.45","price":"3.45","id":40389984452697},{"name":"A$3.57","price":"3.57","id":40389984485465},{"name":"A$3.68","price":"3.68","id":40389984518233},{"name":"A$3.80","price":"3.80","id":40389984551001},{"name":"A$3.91","price":"3.91","id":40389984583769},{"name":"A$4.03","price":"4.03","id":40389984616537},{"name":"A$4.14","price":"4.14","id":40389984649305},{"name":"A$4.26","price":"4.26","id":40389984682073},{"name":"A$4.37","price":"4.37","id":40389984714841},{"name":"A$4.49","price":"4.49","id":40389984747609},{"name":"A$4.60","price":"4.60","id":40389984780377},{"name":"A$4.78","price":"4.78","id":40389984813145},{"name":"A$4.97","price":"4.97","id":40389984845913},{"name":"A$5.15","price":"5.15","id":40389984878681},{"name":"A$5.34","price":"5.34","id":40389984911449},{"name":"A$5.52","price":"5.52","id":40389984944217},{"name":"A$5.70","price":"5.70","id":40389984976985},{"name":"A$5.89","price":"5.89","id":40389985009753},{"name":"A$6.07","price":"6.07","id":40389985042521},{"name":"A$6.26","price":"6.26","id":40389985075289},{"name":"A$6.44","price":"6.44","id":40389985108057},{"name":"A$6.62","price":"6.62","id":40389985140825},{"name":"A$6.81","price":"6.81","id":40389985173593},{"name":"A$7.08","price":"7.08","id":40389985206361},{"name":"A$7.36","price":"7.36","id":40389985239129},{"name":"A$7.64","price":"7.64","id":40389985271897},{"name":"A$7.91","price":"7.91","id":40389985304665},{"name":"A$8.19","price":"8.19","id":40389985337433},{"name":"A$8.46","price":"8.46","id":40389985370201},{"name":"A$8.74","price":"8.74","id":40389985402969},{"name":"A$9.02","price":"9.02","id":40389985435737},{"name":"A$9.48","price":"9.48","id":40389985468505},{"name":"A$9.94","price":"9.94","id":40389985501273},{"name":"A$10.40","price":"10.40","id":40389985534041},{"name":"A$10.86","price":"10.86","id":40389985566809},{"name":"A$11.32","price":"11.32","id":40389985599577},{"name":"A$12.01","price":"12.01","id":40389985632345},{"name":"A$12.70","price":"12.70","id":40389985665113},{"name":"A$13.39","price":"13.39","id":40389985697881},{"name":"A$14.08","price":"14.08","id":40389985730649},{"name":"A$14.77","price":"14.77","id":40389985763417},{"name":"A$15.46","price":"15.46","id":40389985796185},{"name":"A$16.15","price":"16.15","id":40389985828953},{"name":"A$16.84","price":"16.84","id":40389985861721},{"name":"A$17.53","price":"17.53","id":40389985894489},{"name":"A$18.22","price":"18.22","id":40389985927257},{"name":"A$18.91","price":"18.91","id":40389985960025},{"name":"A$19.60","price":"19.60","id":40389985992793},{"name":"A$20.29","price":"20.29","id":40389986025561},{"name":"A$20.98","price":"20.98","id":40389986058329},{"name":"A$21.67","price":"21.67","id":40389986091097},{"name":"A$22.36","price":"22.36","id":40389986123865},{"name":"A$23.05","price":"23.05","id":40389986156633},{"name":"A$25.35","price":"25.35","id":40389986189401},{"name":"A$27.65","price":"27.65","id":40389986222169},{"name":"A$29.95","price":"29.95","id":40389986254937},{"name":"A$32.25","price":"32.25","id":40389986287705},{"name":"A$34.55","price":"34.55","id":40389986320473},{"name":"A$36.85","price":"36.85","id":40389986353241},{"name":"A$39.15","price":"39.15","id":40389986386009},{"name":"A$41.45","price":"41.45","id":40389986418777},{"name":"A$43.75","price":"43.75","id":40389986451545},{"name":"A$46.05","price":"46.05","id":40389986484313},{"name":"A$55.25","price":"55.25","id":40389986517081},{"name":"A$59.85","price":"59.85","id":40389986549849},{"name":"A$64.45","price":"64.45","id":40389986582617},{"name":"A$69.05","price":"69.05","id":40389986615385},{"name":"A$78.25","price":"78.25","id":40389986648153},{"name":"A$87.45","price":"87.45","id":40389986680921},{"name":"A$96.65","price":"96.65","id":40389986713689},{"name":"A$105.85","price":"105.85","id":40389986746457},{"name":"A$115.05","price":"115.05","id":40389986779225},{"name":"A$126.55","price":"126.55","id":40389986811993},{"name":"A$138.05","price":"138.05","id":40389986844761},{"name":"A$149.55","price":"149.55","id":40389986877529},{"name":"A$161.05","price":"161.05","id":40389986910297},{"name":"A$172.55","price":"172.55","id":40389986943065},{"name":"A$184.05","price":"184.05","id":40389986975833},{"name":"A$195.55","price":"195.55","id":40389987008601},{"name":"A$207.05","price":"207.05","id":40389987041369},{"name":"A$218.55","price":"218.55","id":40389987074137}]
}

var OxygenProtection = {
    Init: function() {
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            OxygenProtection.InitWithCart(cart);
            GA4.cart_item(cart);
        });
    },
    InitWithCart: function(cart) {
        var cart_total = 0,
            InsuranceValue = 0,
            Protectionstatus = OxygenProtection.getCookie('Protectionstatus');
        for (t = 0; t < cart.items.length; t++) {
            if (cart.items[t].handle != 'gift-card') {
                cart_total = cart_total + cart.items[t].final_line_price;
            }
        }
        cart_total = cart_total / 100;

        if (cart_total > InsuranceData.threshold_price) {
            var value = OxygenProtection.getClosests(cart_total, InsuranceData.variants);
            
            $('#insurancePrice,.template-cart #insurancePrice').html(Shopify.formatMoney(value.price * 100, window.money_format));
            if (Protectionstatus == "true") {
                InsuranceValue = value.price
            }
        } else {
            $('#insurancePrice,.template-cart #insurancePrice').html(Shopify.formatMoney(InsuranceData.basic_price * 100, window.money_format));
            if (Protectionstatus == "true") {
                InsuranceValue = InsuranceData.basic_price;
            }
        }
        if (Protectionstatus == "true") {
            $('#easy-protection, .template-cart #easy-protection').prop("checked", true);
        } else {
            $('#easy-protection, .template-cart #easy-protection').prop("checked", false);
        }

        cart_total = (Math.abs(parseFloat(cart_total) + parseFloat(InsuranceValue))) * 100;
        $('.totals__subtotal-value, .satcb_checkout_price').html(Shopify.formatMoney(cart_total, window.money_format));
    },
    Checkproduct: function() {
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            var items = cart.items;
            GA4.cart_item(cart);
            items.forEach(function(i, v) {
                if (i.product_id == InsuranceData.product_id || $('.cart-item.active-easy').length != 0) {
                    $('.drawer__cart-items-wrapper .cart-item.active-easy ,#main-cart-items .cart-item.active-easy').find('.quantity__button[name="minus"]').trigger('click');
                }
            });
        });
    },
    AddToCard: function(variant) {
        let formData = { 'items': [{ 'id': variant, 'quantity': 1 }] };
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(response => {
            navigateToCheckout();
        }).catch((error) => {
            navigateToCheckout();
        });
    },
    getClosests: function getClosests(total, variants) {
        var counts = variants,
            goal = total * 2.3 / 100;
        var closest = counts.reduce(function(prev, curr) {
            return Math.abs(parseFloat(curr.price) - parseFloat(goal)) < Math.abs(parseFloat(prev.price) - goal) ? curr : prev;
        });
        return closest;
    },
    CookieInit: function() {
        var Protectionstatus = OxygenProtection.getCookie('Protectionstatus');
        if (Protectionstatus == null) {
            document.cookie = "Protectionstatus=true";
        }
    },
    getCookie: function(name) {
        var cookieArr = document.cookie.split(";");
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if (name == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }
}

$(document).on('click', '#CartDrawer-Checkout, #checkout', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).attr('disabled', 'disabled');
    setTimeout(function() {
        $('#CartDrawer-Checkout, #checkout').removeAttr("disabled");
    }, 7000);
    var EasyStatus = OxygenProtection.getCookie('Protectionstatus');
    if (EasyStatus && EasyStatus == "true") {
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            var cart_total = 0,
                InsuranceValue = 0,
                Protectionstatus = OxygenProtection.getCookie('Protectionstatus'),
                onlygift = true,
                checkInsurance = true;

            for (t = 0; t < cart.items.length; t++) {
                if (cart.items[t].handle != 'gift-card') {
                    cart_total = cart_total + cart.items[t].final_line_price;
                }
            }
            cart_total = cart_total / 100;

            for (i = 0; i < cart.items.length; i++) {
                var Item = cart.items[i];
                if (Item.handle != 'gift-card') {
                    if (Item.properties && Item.properties['_free-product']) {} else {
                        onlygift = false;
                    }
                }
                if (Item.handle == 'easy-insurance') {
                    checkInsurance = false;
                }
            }
            if (cart_total > InsuranceData.threshold_price) {
                var InsuranceVariant = OxygenProtection.getClosests(cart_total, InsuranceData.variants);
                InsuranceVariant = InsuranceVariant.id;
            } else {
                InsuranceVariant = InsuranceData.basic_variant;
            }
            if (onlygift) {
                navigateToCheckout();
            } else {
                if (checkInsurance) {
                    OxygenProtection.AddToCard(InsuranceVariant);
                } else {
                    navigateToCheckout();
                }
            }
        });
    } else {
        navigateToCheckout();
        return;
    }
});
$(document).on('change', '#easy-protection', function() {
    if ($(this).prop("checked") == true) {
        document.cookie = "Protectionstatus=true";
    } else {
        document.cookie = "Protectionstatus=false";
    }
    OxygenProtection.Init();
});
OxygenProtection.Checkproduct();
OxygenProtection.CookieInit();
OxygenProtection.Init();

// Purple Dot required change
// Purple Dot's integration mounts its checkout on top of the /cart page. This checks
// the cart for the presence of an item on pre-order and redirects to /cart if necessary.
// Otherwise, it redirects to the native Shopify /checkout.
async function navigateToCheckout() {
  const cart = await fetch('/cart.js').then(res => res.json());
  
  let hasPreorder = false;
  for (let item of cart.items) {
    if (item.properties && item.properties['__releaseId']) {
      hasPreorder = true;
    }
  }

  if (hasPreorder) {
    window.location.href = '/cart';
  } else {
    window.location.href = '/checkout';
  }
}